import styled from "styled-components";

export const SkeletonRoot = styled.div`
  width: 100%;
  padding: 8px clamp(18px, 3vw, 40px) 64px;
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

export const SkeletonHero = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 36px;
  align-items: stretch;
  min-height: 240px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const SkeletonHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const SkeletonContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 28px;
  border-top: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
`;

export const SkeletonGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

export const SkeletonCard = styled.div`
  width: 300px;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
